import { useTranslation } from 'react-i18next'
import { CurecallTag, CurecallTooltip } from '@honestica/curecall-ui'

export const MissingDocumentFileBadge = () => {
  const { t } = useTranslation()

  return (
    <CurecallTooltip content={t('components.patient-variable-document.file-not-found-tooltip')} size="sm">
      <CurecallTag status="WARNING" size="SMALL">
        {t('components.patient-variable-document.file-not-found')}
      </CurecallTag>
    </CurecallTooltip>
  )
}
